// @ts-nocheck
import { compose } from 'redux';
import type { LocationState } from './reducer';

import type { Location } from '@cobliteam/common-types';

import type { AppState } from '../AppState';
import { history } from '../history';

const selectRouterDomain = (state: AppState): LocationState => state.router;

const selectLocation = compose((state) => state.location, selectRouterDomain);

export const selectLocationPathname = compose(() => history.location.pathname as Location, selectLocation);
